export default __webpack_public_path__ + "static/media/arrow-left.7f016bb6.svg";